import { Box, Lottie, Text } from '@betty/moonlight';
import { Trans } from '@betty/i18n';
import { memo, useEffect, useMemo } from 'react';
import { useDispatch } from '@betty/toolkit/state';
import { acknowledgeStatus } from '../../state/status.slice';
import {
  StatusInstructions,
  StatusResetDisclaimer,
  StatusTitleText,
} from '../../components';
import {
  statusSolidTextTokenMap,
  statusTextTokenMap,
} from '../../content/status.content';
import { StatusUpdatedProps } from './StatusUpdated.types';
import { Platform } from 'react-native';

function StatusUpdated({ variant, status }: StatusUpdatedProps) {
  const dispatch = useDispatch();
  const statusName = status?.playerStatus || 'Member';
  const statusColorProps = useMemo(
    () =>
      Platform.select({
        ios: { gradient: statusTextTokenMap[statusName] },
        web: { gradient: statusTextTokenMap[statusName] },
        android: { color: statusSolidTextTokenMap[statusName] },
      }),
    [statusName],
  );

  useEffect(() => {
    Lottie.present({ animation: 'confetti' });
    dispatch(acknowledgeStatus());
  }, [dispatch]);

  const transComponents = useMemo(
    () => ({
      status: <Text nested variant="body-s-semi" {...statusColorProps} />,
    }),
    [statusColorProps],
  );

  if (!status) {
    return null;
  }

  return (
    <Box alignItems="center" gap="space-400">
      <StatusTitleText locKey={`status_${variant}_title`} />
      <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
        <Trans
          ns="status"
          i18nKey={`status_${variant}_message_a`}
          components={transComponents}
          values={{ status: status.playerStatus }}
        />
      </Text>
      <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
        <Trans
          ns="status"
          i18nKey={`status_${variant}_message_b`}
          components={transComponents}
          values={{ status: status.playerStatus }}
        />
      </Text>
      <StatusInstructions status={status} />
      <StatusResetDisclaimer status={status} />
    </Box>
  );
}

export default memo(StatusUpdated);
